import React, { useMemo, createContext, useContext } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import Global from '../../../store/global-selectors';
import { InventoryService } from '../../../services/inventory-service';
import { useInventoryManagementBasicFeatureGate } from '../../../feature-gates/use-inventory-management-basic-feature-gate';

// TODO: Eventually switch this to make the /getstocklevels api call itself, instead of getting values from redux
const useInventoryInfoFromRedux = () => {
  const inventoryInfo = useSelector(Global.selectOrderDetailsInventoryInfo);
  return inventoryInfo;
};

const InventoryStockLevels = createContext({});
export const useInventoryStockLevels = () => useContext(InventoryStockLevels);

export const InventoryStockLevelsProvider = ({ children, fulfillmentPlanId }) => {
  const inventoryInfo = useInventoryInfoFromRedux();
  const { isFeatureEnabled: isInventoryManagementBasicFeatureEnabled } = useInventoryManagementBasicFeatureGate();

  const inventoryStockLevelsMap = useMemo(() => {
    const { stockLevelInfo = [] } = inventoryInfo || {};
    return stockLevelInfo.reduce((acc, itemStockLevelInfo) => {
      return {
        ...acc,
        [itemStockLevelInfo.fulfillmentPlanItemId]: itemStockLevelInfo,
      };
    }, {});
  }, [inventoryInfo]);

  const shouldShowInventoryInfo = useSelector((state) => InventoryService.shouldItemInventoryInformationShow(state, fulfillmentPlanId));
  const shouldShowInventoryInfoUiTreatments = useSelector((state) =>
    InventoryService.canFulfillmentPlanBeAllocated(state, fulfillmentPlanId),
  );

  const value = useMemo(
    () => ({
      inventoryInfo,
      inventoryStockLevelsMap,
      shouldShowInventoryInfo: isInventoryManagementBasicFeatureEnabled && shouldShowInventoryInfo,
      shouldShowInventoryInfoUiTreatments: isInventoryManagementBasicFeatureEnabled && shouldShowInventoryInfoUiTreatments,
    }),
    [
      inventoryInfo,
      inventoryStockLevelsMap,
      shouldShowInventoryInfo,
      shouldShowInventoryInfoUiTreatments,
      isInventoryManagementBasicFeatureEnabled,
    ],
  );

  return <InventoryStockLevels.Provider value={value}>{children}</InventoryStockLevels.Provider>;
};

InventoryStockLevelsProvider.propTypes = {
  children: PropTypes.node.isRequired,
  fulfillmentPlanId: PropTypes.string.isRequired,
};
